import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { WebStorageService } from '../services/web-storage/web-storage.service';
import { STORAGE_SESSION_KEY } from './constants';
import { catchError } from 'rxjs/operators';


@Injectable()
export class SessionKeyHttpInterceptor implements HttpInterceptor {
  constructor(private _storage: WebStorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let sessionKey = this._storage.session.get(STORAGE_SESSION_KEY);
    if (sessionKey) {
      // X-Session-Key-Header: fetched session key
      req = req.clone({
        setHeaders: {
          'x-session-key-header': sessionKey
        }
      });
    }

    return next.handle(req)
      .pipe(catchError((error) => {
        return throwError(error);
      }));
  }
}
